import TempleDetailsCard from "../../components/card/Temple/TempleDetailsCard";
import { Box, CircularProgress, Grid } from "@mui/material";
import {
  getImageListFromTemple,
  getTempleName,
} from "../../utils/HelperFunctions";
import { LOCALSTORAGE_KEY } from "../../utils/Constants";
import PrasadTempleContent from "../../components/BlogContent/PrasadTempleContent";
import "../Temple/TempleView.scss";

const PrasadView: React.FC<any> = (props) => {
  const savedLanguage =
    localStorage.getItem(LOCALSTORAGE_KEY.LANG_CODE) ?? "en";
  return (
    <Box className="pageContainer templePage" data-scroll-id={"temple-list-prasad"}>
      <Box className="templeBlock">
        <Grid container spacing={1}>
          <Grid item xs={12} md={2} lg={2} xl={2} className="templeLeftBlock">
            {/* <LeftAddressCard
              header={props.TDTexts.CURRENTADDRESS}
              address={
                props.userAddressList && props.userAddressList.length > 0
                  ? props.userAddressList[0].formatted_address
                  : ""
              }
              footerButton="Edit or add an address"
            /> */}
          </Grid>
          <Grid item xs={12} md={8} lg={8} xl={8}>
            <Box className="templeCenterBlock">
              {props?.isLoading && (
                <Box className="loaderContainer">
                  <CircularProgress />
                </Box>
              )}
              {props?.templeList &&
                props?.templeList.map((item: any, id: any) => {
                  let prasadImageList = getImageListFromTemple(
                    item.personalInfo,
                    "prasadPictures"
                  );
                  const templeName = getTempleName(item, savedLanguage);
                  const singlePrasadImg = item?.personalInfo?.media?.prasadTempleCardImg?.length > 0 ? item?.personalInfo?.media?.prasadTempleCardImg[0]?.pictureUrl : null;
                  return (
                    <TempleDetailsCard
                      id={id}
                      key={`templeCenterBlock${id}`}
                      templeData={item}
                      templePictures={prasadImageList}
                      templeCardImage={singlePrasadImg}
                      overlayText={item?.personalInfo?.overlayText?.prasadTempleOverlayText ?? null}
                      overlayCss={item?.personalInfo?.overlayCss?.prasadTempleOverlayCss ?? null}
                      templeImage={
                        item?.personalInfo &&
                        item?.personalInfo?.media &&
                        item?.personalInfo?.media?.pictures &&
                        item?.personalInfo?.media?.pictures.length > 0
                          ? item?.personalInfo?.media?.pictures[0].pictureUrl
                          : ""
                      }
                      verificationStatus={item?.verifications?.status}
                      templeName={templeName}
                      descriptions={item?.personalInfo?.descriptions}
                      // descriptions='The Jagannath Temple is an important Hindu temple dedicated to Jagannath, a form of Vishnu–one of the trinity of supreme'
                      selectTemple={props?.selectTemple}
                      googleData={item?.googleData}
                    />
                  );
                })}
            </Box>
          </Grid>
          <Grid item xs={12} md={2} lg={2} xl={2} className="templeRightBlock">
            {/* <RightBlockCard /> */}
          </Grid>
        </Grid>
        <Box className="bottomBlogContent">
          <PrasadTempleContent/>
        </Box>
      </Box>
    </Box>
  );
};

export default PrasadView;
